"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isOnboarding = void 0;
var date_fns_1 = require("date-fns");
var constants_1 = require("../constants");
// There is some complexity around what "onboarding" means, this mirrors
// existing logic. Missing MSN indicates that meter data has not yet arrived
// and so inlife reads will not be ready to view
// If meter technical details have not yet arrived, we create a dummy meter
// to hold any OMR reads
//Is today less than 6 days after supply start date?
var isInOmrWindow = function (supplyStartDate) {
    return (0, date_fns_1.isBefore)((0, date_fns_1.startOfToday)(), (0, date_fns_1.addDays)(new Date(supplyStartDate), constants_1.ONBOARDING_DAYS));
};
var isOnboarding = function (supplyStartDate, msn) { return isInOmrWindow(supplyStartDate) || msn === constants_1.DUMMY_MSN; };
exports.isOnboarding = isOnboarding;
